import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { useBranchContext } from "@/hooks/useBranchContext";
import { useOrganizationContext } from "@/hooks/useOrganizationContext";

export const useMDCompletionTime = (patientId?: string) => {
  const { currentBranchId } = useBranchContext();
  const { organizationId } = useOrganizationContext();
  return useQuery({
    queryKey: ["md-completion-time", organizationId, currentBranchId, patientId],
    queryFn: async () => {
      if (!patientId || currentBranchId == null || !organizationId) return null;
      const { data, error } = await supabase
        .from("activities").select("completion_time")
        .eq("patient_id", patientId).eq("workflow_step", "MD").eq("status", "completed")
        .eq("branch_id", currentBranchId).eq("organization_id", organizationId)
        .maybeSingle();
      if (error) { console.error("Error fetching MD completion time:", error); return null; }
      return data?.completion_time || null;
    },
    enabled: !!patientId && currentBranchId != null && !!organizationId,
    staleTime: 30 * 1000,
    gcTime: 5 * 60 * 1000,
  });
};
